import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import { ProtectedRouteProps } from '../../types/components';

/**
 * AdminProtectedRoute component restricts access to admin-only routes
 * 
 * Only users with admin role can access these routes.
 * Regular users and public users are redirected to the home page.
 * 
 * @param children - The components to render if access is allowed
 * @returns The protected route content or a redirect
 */
function AdminProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAdmin } = useUser();
  
  if (!isAdmin) {
    // Redirect non-admin users to home page
    return <Navigate to="/" replace />;
  }

  // User is admin, allow access
  return <>{children}</>;
}

export default AdminProtectedRoute; 